import React from "react";
import "./generate.scss";

const Generate = () => {
  return (
    <div className="container">
      <div className="generate_wrapper">
        <div className="generate_img">
          <img src="./images/generate_bg.webp" alt="radio" />
        </div>
        <div className="generate_desc">
          <h1>Streamline Your Operations, Accelerate 30% Guaranteed.</h1>
          <div>
            <a href="#Book">
            <button>WORK WITH US</button>

            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Generate;
